module.exports = __webpack_public_path__ + "img/bg-pot.575457a3.png";